import React from 'react';
import styles from '../Operations.module.css';
import KpiFocusArea from '../../../../components/kpifocusarea';

interface EOQMSComponent extends React.FC {
  title?: string;
  kpiHyperlink?: string;
  actionTitle?: string;
  actionHyperlink?: string;
  actionContent?: React.FC;
  actionDrawerWidth?: number;
}

/**
 * EOQMS - EOQ (MaxStock) Adds and Adjusts
 * KPI information component
 */
const EOQMS: EOQMSComponent = () => {
  return (
    <div className={styles.container}>
      <div className={styles.sectionTitle}>Metric Description</div>

      <div className={styles.sectionContent}>
        Economic Order Quantities (EOQ) are established to minimize put away expense, control labor
        hours, maximize sales opportunity, and drive an optimal shelf quantity.
        <br />
        EOQ is measured via Economic Order Quantity (Max Stock) Acceptance.
      </div>

      <div className={styles.sectionContent}>
        The acceptance percentage specified in the Current column is re-calculated monthly based on
        your store&apos;s count of EOQ Items with an existing
        <br />
        &quot;effective&quot; Max stock level / total number of EOQ candidates.
        &quot;Effective&quot; is defined as:
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;• Not exceeding the max recommendation by an amount greater than a 30 weeks of supply
        <br />&nbsp;&nbsp;&nbsp;&nbsp;• Not reducing the max recommendation by 4 or more units, or a value greater than 75%
      </div>

      <div className={styles.sectionTitle}>Supporting Details</div>

      <div className={styles.sectionContent}>
        Via the power of Mango Report ®, EOQ makes monthly recommendations at the SKU-level based
        on both global and store specific data points.
        <br />
        The average store impact is as follows:
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;• 430 SKUs, additional ~$4K in inventory
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;• 9,500 less lines per year (replenish 6 times / year instead of 28 times / year)
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;• 80 labor hours saved per year / store putting away truck
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;• $30K in incremental retail sales
      </div>

      <div className={styles.sectionTitle}>Goal</div>

      <div className={styles.sectionContent}>
        Economic Order Quantity (Max Stock) Acceptance is &gt;= 80%
      </div>

      <div className={styles.sectionTitle}>Learn More</div>

      <div className={styles.sectionContent}>
        1. Review Ace Way of Retailing documentation on{' '}
        <a
          href="https://acenet.aceservices.com/awor/ordering/economic-order-quantities"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.link}>
          Economic Order Quantity
        </a>
        <br />
        2. Take the Ace Learning Place course - search for “EOQ”
      </div>
    </div>
  );
};

/**
 * EOQMSTakeAction - Take Action drawer content for EOQ
 * Displayed when user clicks the "SET ECONOMIC ORDER QTY" button
 */
const EOQMSTakeAction: React.FC = () => (
  <KpiFocusArea
    kpiCodes={['EOQMS']}
    gridName="Economic Order Quantity"
    cardName="FocusArea"
    automationLinks={[
      { label: 'EOQ (Max Stock) Adds & Adjusts', urlCode: 'EOQMS', urlField: 'automationurl' },
      { label: 'EOQ (Max Stocks) Removes', urlCode: 'EOQMR', urlField: 'automationurl' },
    ]}
    automationTitle="For Optimal Shelf Quantity Automation:"
  />
);

EOQMS.title = 'Economic Order Quantity';
EOQMS.kpiHyperlink = 'dynamicURL:ACENET:description';
EOQMS.actionTitle = 'Set Economic Order Qty';
EOQMS.actionContent = EOQMSTakeAction;
EOQMS.actionDrawerWidth = 920;
export default EOQMS;
